import { useState } from 'react'
import { Body, Box, Dialog, H4, WhatsThis } from './'

export const PasswordRequirements = ({ dark, ...props }) => {
  const [passwordRequirementsOpen, setPasswordRequirementsOpen] = useState(false)

  return (
    <>
      <Dialog
        open={passwordRequirementsOpen}
        onClose={() => setPasswordRequirementsOpen(false)}
        mobileBackground="white"
        mobileDrawer={false}
      >
        <Box column gap={16}>
          <H4 color="black">Password requirements</H4>
          <ul style={{ color: 'black' }}>
            <li><Body>Be at least 8 characters long</Body></li>
            <li>Contain an upper case character</li>
            <li>Contain a lower case character</li>
            <li>Contain a number</li>
          </ul>
        </Box>
      </Dialog>
      <WhatsThis
        onClick={() => setPasswordRequirementsOpen(true)}
        text="Password requirements"
        color={dark ? 'black' : 'white'}
        {...props}
      />
    </>
  )
}